const binding = { modules: {}, dataActions: {} };

    (binding.modules['ext-sign-up'] = {
        c: () => require('partner/modules/ext-sign-up/ext-sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ext-sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ext-sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ext-sign-up|ext-sign-up'] = {
                c: () => require('partner/modules/ext-sign-up/ext-sign-up.view.tsx'),
                cn: '__local__-__local__-ext-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };